
Grid = window.Grid || {};


Grid.PagerComponent = {
    	templateUrl: 'framework/partials/grid/pager.html',
    	bindings: {
    		listController: '=',
    	},
 		controllerAs: 'pageCtrl',
 		transclude: true,
    	controller: function() {
    		var self = this;
    		this.rows_per_page_selection = [2,25,50,100,500];
    		this.cache = {}
    		this.isSearchAvailable = function() {
    			return typeof self.listController.state.showSearch != "undefined";
    		}
    		this.toggleSearch = function() {
    			self.listController.state.showSearch = !self.listController.state.showSearch;
    		}
    		
    		this.arePrefsAvailable = function() {
    			return self.listController.options.length > 0;
    		}

    		this.isExportAvailable = function() {
    			if (!this.cache.isExportAvailable) {
    				this.cache.isExportAvailable = self.listController.isExportAvailable();
    			}
    			return this.cache.isExportAvailable;
    		}

    		this.showPrefs = function() {
    			self.listController.showPrefs();
    		}

    		this.export = function(format) {
    			self.listController.export(format);
    		}
    		
    		//$scope.$watch(function(){return self.listController.objects_count}, function(){ 
			this.listController.getPage.subscribe(function(objects){
				self.page = self.listController.params.offset / self.listController.params.limit + 1;
				self.pages = Math.max(1, Math.ceil((self.listController.objects_count.filtered || 0) / self.listController.params.limit));
				self.prevPage = self.page;
    		});
    		
    		this.addPage = function(delta) {
    			self.page += delta;
    			self.changePage();
    		}
    		
    		this.firstPage = function() {
    			self.page = 1;
    			self.changePage();
    		}
    		
    		this.lastPage = function() {
    			self.page = self.pages;
    			self.changePage();
    		}
    		
    		this.changePage = function() {
    			if (self.page < 1) self.page = 1;
    			if (self.page > self.pages) self.page = self.pages; 
				if (self.prevPage != self.page) {
					self.listController.params.offset = (self.page - 1) * self.listController.params.limit;
					self.listController.getPage();
					self.prevPage = self.page;
				}
    		}
    		
    		this.setPageSize = function(n) {
    			self.listController.setRowsPerPage(n);
    			self.prevPage = null;
    			self.firstPage();
    		}
    		
    		this.reload = function() {
    			self.listController.getPage();
    		}
    		
    		window.pageCtrl = this;
    		
    	}
}